import React from "react";

import { Button } from "src/app/components/Button/Button";
import {
  DropdownMenu,
  DropdownMenuItem,
} from "src/app/components/Dropdown/Dropdown";
import { DropdownPortal } from "src/app/components/DropdownPortal/DropdownPortal";

import { ReactComponent as FilterIcon } from "src/images/filter.svg";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { getRolesForContext } from "src/app/SettingsModal/tabs/Members/utils";
import { camelCaseToSeparatedWords } from "src/utils/methods";
import { ReactComponent as TickBlueIcon } from "../../../images/tick-blue.svg";

export function UserListFilter({ filteredGroup, setFilteredGroup, context }) {
  const filteredRoles = getRolesForContext(context);

  const menu = (
    <DropdownMenu isOpen>
      <DropdownMenuItem onClick={() => setFilteredGroup("all")}>
        <IDHFormattedMessage id="ws_all" defaultMessage="All" />
        {filteredGroup === "all" && (
          <TickBlueIcon
            width={20}
            height={20}
            className="dropdown__tick-blue"
          />
        )}
      </DropdownMenuItem>
      {filteredRoles.map((role) => (
        <DropdownMenuItem onClick={() => setFilteredGroup(role)}>
          <IDHFormattedMessage
            id={`ws_${role}`}
            defaultMessage={camelCaseToSeparatedWords(role)}
          />
          {filteredGroup === role && (
            <TickBlueIcon
              width={20}
              height={20}
              className="dropdown__tick-blue"
            />
          )}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );

  return (
    <DropdownPortal overlay={menu}>
      <Button variant="white">
        <FilterIcon />
        &nbsp;
        <IDHFormattedMessage id="ws_show" defaultMessage="Show" />
        :&nbsp;
        <span style={{ textTransform: "capitalize" }}>{filteredGroup}</span>
      </Button>
    </DropdownPortal>
  );
}
